<script setup lang="ts">
    import ContinueButton from '@/components/ContinueButton.vue';
    import { useI18n } from 'vue-i18n';
    import { useMutation } from '@tanstack/vue-query';
    import axios from 'axios';
    import { toast } from 'vue-sonner';
    import QueryKey from '@/enums/QueryKey';
    import { useQueryClient } from '@tanstack/vue-query';
    import type { VatSubmission, SharedData } from '@/types';
    import { useVatStore } from '@/stores/vat';
    import { computed, ref } from 'vue';
    import { usePage } from '@inertiajs/vue3';

    const props = defineProps<{
        vatSubmission: VatSubmission;
    }>();

    const { t } = useI18n();
    const queryClient = useQueryClient();
    const vatStore = useVatStore();
    const page = usePage<SharedData>();

    const selectedCompanyId = computed(() => page.props.auth.user.selected_company_id);
    const submitted = ref(false);

    const { mutate, isPending } = useMutation({
        mutationFn: (vatSubmissionId: number) =>
            axios.post(route('v2.vat.submission.submit', vatSubmissionId)),
        onSuccess: (data) => {
            submitted.value = true;
            toast.success(t('vat.submission_successful'));
            queryClient.invalidateQueries({
                queryKey: [
                    QueryKey.VAT,
                    selectedCompanyId,
                    vatStore.date,
                    vatStore.selectedGrouping,
                ],
            });
        },
        onError: (error: any) => {
            console.log('error', error);
            toast.error(error.response.data.message || t('vat.submission_failed'));
        },
    });

    function submitVat() {
        if (isPending.value) return;
        mutate(props.vatSubmission.id);
    }
</script>

<template>
    <ContinueButton
        :disabled="!vatSubmission.purchase_vat || !vatSubmission.sales_vat"
        :loading="isPending || submitted"
        @click="submitVat"
    >
        {{ t('vat.submit') }}
    </ContinueButton>
</template>
